import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { Hero, HeroContainer } from '@/modules/common/components/Hero';
import { BackButton } from '@/modules/common/components/buttons';
import { Header } from './components/Header';
import { About } from './components/About';
import { Cancellation } from './components/Cancellation';
import { Benefits } from './components/Benefits';
import { Regulation } from './components/Regulation';
import { Activation } from './components/Activation';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { RLPPageData, RLPStatus } from '@/modules/trade/services/rlp';
import { RLPPageStatus, RLPSteps } from '../../types';

interface Props {
  pageData: RLPPageData;
  pageStatus: RLPPageStatus;
}
interface Emits {
  (e: 'change-step', step: RLPSteps): void;
  (e: 'refresh'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Information',
  props: {
    pageData: null,
    pageStatus: null
  },
  emits: ["change-step", "refresh"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change-step', step: RLPSteps): void;
  (e: 'refresh'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageData: RLPPageData;
  pageStatus: RLPPageStatus;
};





const router = useRouter();

const isLoading = computed(() => {
  return props.pageStatus === RLPPageStatus.Loading;
});

const hasError = computed(() => {
  return props.pageStatus === RLPPageStatus.Error;
});

const isRLPEnabled = computed(() => {
  return props.pageData?.status === RLPStatus.Active;
});

const isRLPDisabled = computed(() => {
  return props.pageData?.status === RLPStatus.Inactive;
});

const emitRefresh = () => {
  emit('refresh');
};

const handleRLPCancellation = () => {
  emit('change-step', RLPSteps.CancellationForm);
};

const handleGoBack = () => {
  router.push({ name: 'trade' });
};

return { __sfc: true,props, emit, router, isLoading, hasError, isRLPEnabled, isRLPDisabled, emitRefresh, handleRLPCancellation, handleGoBack, NavBar, LoaderIndicator, HelperViewStatus, Hero, HeroContainer, BackButton, Header, About, Cancellation, Benefits, Regulation, Activation, NebraskaColors }
}

})